import { motion } from "framer-motion";
import { useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface ToolCardImageProps {
  imageUrl: string;
  name: string;
  compact?: boolean;
}

export const ToolCardImage = ({ imageUrl, name, compact = false }: ToolCardImageProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  return (
    <motion.div 
      className={`relative ${compact ? 'h-20' : 'h-24'} overflow-hidden bg-white/50 dark:bg-gray-700/50 flex items-center justify-center p-4 border-b border-gray-100 dark:border-gray-700`}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.2 }}
    > 
      {isLoading && !hasError && (
        <Skeleton className={`${compact ? 'w-16 h-16' : 'w-16 h-16'} rounded-full`} />
      )}
      
      <img 
        src={imageUrl || '/placeholder.svg'} 
        alt={name}
        onLoad={() => setIsLoading(false)}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = '/placeholder.svg';
          setHasError(true);
          setIsLoading(false);
        }}
        className={`
          ${compact ? 'w-16 h-16' : 'w-16 h-16'} 
          rounded-full object-cover border-4 border-white 
          dark:border-gray-700 shadow-sm transition-transform duration-300
          ${isLoading ? 'opacity-0' : 'opacity-100'}
        `}
        loading="lazy"
        decoding="async"
      />
    </motion.div>
  );
};